module.exports = __webpack_public_path__ + "static/media/C_8.e200e643.png";